// extracted by mini-css-extract-plugin
module.exports = {"login":"styles_login__qbPUP","logo":"styles_logo__1uFdK","form":"styles_form__w1xm3","submit":"styles_submit__2zbp3","progress":"styles_progress__3xOvp"};